import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../../../../../environments/environment'
import { ApiUrls } from '../../../../../../shared/constants/enums'
import {
    ClientUserRepresentativeDto,
    RepresentativeNotificationDto
} from '../../../../../../shared/models/setting.interfaces'

@Injectable()
export class SettingApiService {
    private representativeResourceUrl: string = `${environment.backendUrl}/${ApiUrls.representatives}`

    constructor(private http: HttpClient) {}

    getRepresentative(): Observable<ClientUserRepresentativeDto> {
        return this.http.get<ClientUserRepresentativeDto>(this.representativeResourceUrl)
    }

    updateRepresentativeNotifications(notificationDtos: RepresentativeNotificationDto[]): Observable<void> {
        return this.http.put<void>(this.representativeResourceUrl, notificationDtos)
    }
}
